import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

import moment from 'moment';
import { useForm } from '../forms/useForm';
import { ConfigServer } from '../../data/config';
import { Tag } from 'primereact/tag';
import * as XLSX from 'xlsx';



export const useWorkOrderDay = () => {

    let id_branch = localStorage.getItem('branchId');
    let token = localStorage.getItem("token");
    const history = useHistory();

    useEffect(() => {
        getBranches();
        getTypeService();
        setLocalStorageValues();
        getSections().then(resp => {
            getWorkOrdersDay(moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), id_branch, 0, false, false, true, resp, true, false, '', '', false);
        });
    }, [])

    const [createSweet] = useSweetAlert();
    const [loading, setLoading] = useState(false);
    //Branches and printers
    const [branches, setBranches] = useState([]);
    //Sections
    const [sections, setSections] = useState([]);
    const [sectiondefault, setSectiondefault] = useState(null);
    const [selectedSections, setselectedSections] = useState(null);
    // console.log("🥘 selectedSections", selectedSections);

    //detail and indicadores
    const [totalWorkOrderUrgent, setTotalWorkOrderUrgent] = useState(0);
    const [totalWorkOrderCritic, setTotalWorkOrderCritic] = useState(0);
    const [totalWorkOrderNormal, setTotalWorkOrderNormal] = useState(0);
    const [totalWorkOrder, setTotalWorkOrder] = useState(0);
    const [workOrders, setWorkOrders] = useState([]);
    const [listExams, setListExams] = useState([])
    // console.log("🌈 listExams", listExams);

    const [match_exact, setMatchExact] = useState(false);

    //* SELECTED TYPE SERVICE
    let validHopitalInterfaced = localStorage.getItem('interfaced');
    const [dataTypeService, setDataTypeService] = useState([]);

    // ? CONFIGURATION DATA TABLE
    const [expandedRows2, setExpandedRows2] = useState(null);
    const [filterType, setFilterType] = useState(null);
    const [hasStoredSearch, setHasStoredSearch] = useState(false);
    const treeviewRef = useRef(null);


    // ? CONFIGURATION TRACEABILITY
    const [loadingTrazability, setLoadingTrazability] = useState(false)
    const [dataTraceability, setDataTraceability] = useState([])
    const opTraceability = useRef(null);
    const [selectedNim, setSelectedNim] = useState("");
    let _capture_lock = localStorage.getItem('capture_lock');
    let enable_tracking_toma = localStorage.getItem('enable_tracking_toma');
    let _menu = localStorage.getItem('menu');




    const [globalFilter2, setGlobalFilter2] = useState(() => {
        return localStorage.getItem("workOrdersSearch") || "";
    });

    //#region Form
    const [filterRangeNims, setFilterRangeNims] = useState({
        date_range_nim: new moment().format('YYYY/MM/DD'),
        branch_range_nim: "",
        init_range_nim: "0",
        end_range_nim: "1"
    });

    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues] = useForm({
        mDateRange1: moment().format("YYYY-MM-DD"),
        mDateRange2: moment().format("YYYY-MM-DD"),
        mSelectBranch: 0,
        nim: "",
        mSelectStatus: 0,
        mExam: 0,
        mSelectTypeService: 0,

    });


    const {
        mDateRange1, mDateRange2, mSelectBranch, nim, mSelectStatus, mExam, mSelectTypeService
    } = formValues;


    //#endregion Form
    useEffect(() => {
        if (branches.length > 0) {
            let _find = branches.find(x => x.value == parseInt(id_branch))
            handleUpdateValues({
                ...formValues,
                mSelectBranch: _find
            });
        }
    }, [branches]);

    //status
    const [statusOrder, setstatusOrder] = useState([
        {
            value: 1,
            label: "abierta"
        },
        {
            value: 4,
            label: "validado"
        },
        {
            value: 5,
            label: "parcial"
        },
        {
            value: 6,
            label: "liberado"
        },
        {
            value: 7,
            label: "enviado"
        },
        {
            value: 8,
            label: "entregado"
        },
        {
            value: 10,
            label: "autorizado"
        },
        {
            value: 20,
            label: "cancelada"
        },
    ]);

    const getBranches = async () => {
        let _listTemp = await handleRequest("GET", "Branch/List", "Sucursal");
        if (_listTemp !== null && _listTemp.length > 0) {
            let _newBranches = [];
            _listTemp.forEach((_obj) => {
                let _validB = _obj.code + "-" + _obj.name
                _newBranches.push({
                    value: _obj.id_branch,
                    label: _validB
                });
            });
            setBranches(_newBranches);
        }
    }

    const getSections = async () => {
        let _listTemp = await handleRequest("GET", "Section/List/false", "Secciones");

        if (_listTemp !== null && _listTemp.length > 0) {
            let _secciones_vinculadas = JSON.parse(localStorage.getItem("sections"));
            let _secciones_guardadas = localStorage.getItem("filter_sections");
            if (_secciones_guardadas != '[]') {
                _secciones_guardadas = JSON.parse(_secciones_guardadas);
            }
            let secciones = [];
            let sectionmultiselect = [];
            let sectiondefault = [];
            _listTemp.forEach(({ id_section, name }) => {
                _secciones_vinculadas.forEach(function (element, index, _secciones_vinculadas) {
                    if (element == id_section) {
                        let checkAux = false;
                        if (_secciones_guardadas != '[]') {
                            let validacion = _secciones_guardadas.find(x => x.id_section === id_section);
                            if (validacion !== undefined) {
                                checkAux = true;
                                sectiondefault.push(
                                    { name: name, code: id_section },
                                )
                            } else {
                                checkAux = false;
                            }
                        } else if (_secciones_guardadas == "[]") {
                            sectiondefault.push(
                                { name: name, code: id_section },
                            )
                            checkAux = true;
                        }
                        secciones.push({
                            id_section: id_section,
                            name: name,
                            check: checkAux,
                            label: name,
                            value: id_section
                        })
                        sectionmultiselect.push(
                            { name: name, code: id_section },
                        )
                    }
                });
            });
            setSections([...secciones]);
            setSectiondefault(sectionmultiselect);
            setselectedSections(sectiondefault);
            if (_secciones_guardadas == "[]") {
                localStorage.setItem("filter_sections", JSON.stringify(secciones));
            }
            return secciones;
        }
    }

    const changeCheckbox = (e) => {

        let _array = sections;
        let sectionfind = [];
        _array.map(_obj => {
            if (e.some(x => x.code === _obj.id_section)) {
                sectionfind.push(
                    { name: _obj.name, code: _obj.id_section },
                )
                getFilterExams(_obj.id_section)

            }
            return _obj;
        });
        _array.map(_obj => {

            if (e.some(x => x.code === _obj.id_section)) {
                _obj.check = true;
            } else {
                _obj.check = false;
            }
            return _obj;
        });
        let filter_sections = _array.filter(x => x.check === true);
        localStorage.setItem("filter_sections", JSON.stringify(filter_sections));
        localStorage.setItem("sectionfind", JSON.stringify(filter_sections));
        setselectedSections(sectionfind);
        setSections(_array);
    }

    //#region WorkOrders
    const getWorkOrders = (e, search = false, boton = false, buttonValue = "", _valid = false) => {
        console.log("🚀 ~ getWorkOrders ~ _valid:", _valid)
        console.log("🚀 ~ getWorkOrders ~ buttonValue:", buttonValue)
        console.log("🚀 ~ getWorkOrders ~ boton:", boton)
        console.log("🚀 ~ getWorkOrders ~ search:", search)
        e.preventDefault();
        let query = "";
        if (!search) {
            let _idBranch = 0;
            let _idExam = 0;

            if (formValues.mExam != undefined && formValues.mExam !== null) {

                if (formValues.mExam.value !== 0) {
                    _idExam = mExam.value;
                }
                else {
                    _idExam = 0;
                }
            }
            if (formValues.mSelectBranch != undefined && formValues.mSelectBranch !== null) {
                if (formValues.mSelectBranch.value !== 0) {
                    _idBranch = mSelectBranch.value;
                }
                else {
                    _idBranch = 0;
                }
            }
            else {
                _idBranch = 0;
            }

            if (mSelectStatus !== 0) {
                query += `?&id_estatus_order=${mSelectStatus.value}`;
            }
            if (buttonValue === 'Interfazados') {
                query += `?id_estatus_order=${0}&only_interface_unchecked=${true}`;
                getWorkOrdersDay(formValues.mDateRange1, formValues.mDateRange2, (_idBranch !== undefined ? _idBranch : 0), query, false, search, false, null, false, boton, buttonValue);
            } else {

                handleUpdateValues({
                    ...formValues,
                    nim: "",
                })
                getWorkOrdersDay(formValues.mDateRange1, formValues.mDateRange2, (_idBranch !== undefined ? _idBranch : 0), query, false, search, false, null, false, boton, _idExam);
            }
        } else {
            if (nim.length <= 0) {
                alert("Debes ingresar minimo un caracter para buscar");
                return;
            }
            localStorage.removeItem("workOrdersSearch");
            setGlobalFilter2("");
            let _idBranch = 0;
            getWorkOrdersDay(formValues.mDateRange1, formValues.mDateRange2, (_idBranch !== undefined ? _idBranch : 0), query, false, search, false, null, false, boton, _valid);
        }
    }

    const setLocalStorageValues = async () => {
        var local_request = localStorage.getItem('request_workorder_listworkorder');

        if (local_request != null) {
            var request = JSON.parse(local_request);

            handleUpdateValues({
                ...formValues,
                mSelectBranch: request.id_branch,
                mDateRange1: request.date1,
                mDateRange2: request.date2,
                mExam: request.gatos ?? 0
            });
        }
    }

    const resetLocalStorage = async () => {
        localStorage.removeItem('request_workorder_listworkorder');
        localStorage.removeItem('current_work_orders')
        handleUpdateValues({
            ...formValues,
            mSelectBranch: parseInt(localStorage.getItem('branchId')),
            mDateRange1: moment().format("YYYY-MM-DD"),
            mDateRange2: moment().format("YYYY-MM-DD"),
            mExam: 0,
            mSelectTypeService: 0,
        });
        window.location.reload();
    }


    const getWorkOrdersDay = async (date1, date2, id_branch, query, is_critic = false, search = false, first = false, arraySections = null, allSections = false, boton = false, gatos, type_service = false) => {
        let _formulario = (allSections) ? arraySections : (arraySections === null ? sections.filter(x => x.check === true) : arraySections.filter(x => x.check === true));

        let _validnew = mExam.value
        let _valid = gatos


        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(_formulario)
        };
        setLoading(true);
        if (date1._d !== undefined) {
            date1 = moment(date1._d).format("YYYY-MM-DD");
        }
        else {
            date1 = moment(date1).format("YYYY-MM-DD");
        }

        if (date2._d !== undefined) {
            date2 = moment(date2._d).format("YYYY-MM-DD");
        }
        else {
            date2 = moment(date2).format("YYYY-MM-DD");
        }
        var _respuesta = {};
        let _alterUrl = "";

        if (is_critic === true) {
            if (id_branch !== null) {
                if (id_branch.value !== undefined) {
                    _alterUrl = `?id_branch=${id_branch.value}`;
                }
            }
            if (nim !== "") {
                _alterUrl = `?nim=${nim}`;



                requestOptions = {
                    ...requestOptions,
                    method: 'GET'
                }
            }
            _respuesta = await sendRequest(requestOptions, `WorkOrder/ListDetailUrgentCriticTest/${date1}/${date2}${_alterUrl}`);
        }
        else if (search === false) {

            let vaild = (query == 0 || query == undefined) ? "" : query;
            var local_request = localStorage.getItem('request_workorder_listworkorder');

            if (local_request == null || boton) {


                if (_validnew === 0 || _validnew === undefined) {

                    if (validHopitalInterfaced === "True") {
                        if (formValues.mSelectTypeService.value > 0) {
                            _respuesta = await sendRequest(requestOptions, `WorkOrder/ListWorkOrder/${date1},${date2},${id_branch}?id_estatus_order=0&ids_work_order_type_service=${formValues.mSelectTypeService.value}` + vaild);
                        }
                        else {
                            _respuesta = await sendRequest(requestOptions, `WorkOrder/ListWorkOrder/${date1},${date2},${id_branch}` + vaild);
                        }
                    }
                    else {
                        _respuesta = await sendRequest(requestOptions, `WorkOrder/ListWorkOrder/${date1},${date2},${id_branch}` + vaild);
                    }
                }
                else {
                    _respuesta = await sendRequest(requestOptions, `WorkOrder/ListWorkOrder/${date1},${date2},${id_branch}?ids_exams=${gatos}` + vaild);
                }
            }
            else {

                var request = JSON.parse(local_request);
                requestOptions.body = request.body;
                id_branch = request.id_branch;
                date1 = request.date1;
                date2 = request.date2;
                gatos = request.gatos;
                _formulario = JSON.parse(request.body)

                if (gatos === "" || gatos === undefined) {
                    _respuesta = await sendRequest(requestOptions, `WorkOrder/ListWorkOrder/${request.date1},${request.date2},${request.id_branch}` + request.vaild);

                }

                if (gatos > 0) {
                    if (request.gatos === undefined || request.gatos === "") {
                        _respuesta = await sendRequest(requestOptions, `WorkOrder/ListWorkOrder/${date1},${date2},${id_branch}?ids_exams=${gatos}` + vaild);
                    }
                    else {
                        _respuesta = await sendRequest(requestOptions, `WorkOrder/ListWorkOrder/${request.date1},${request.date2},${request.id_branch}?ids_exams=${request.gatos}` + request.vaild);
                    }
                }
            }
        } else {
            requestOptions = {
                method: 'GET'
            }
            _respuesta = await sendRequest(requestOptions, `WorkOrder/SearchWorkOrderFromNim/${nim}?match_exact=${match_exact}`
            );
        }

        if (_respuesta.code === 200) {

            var nims = _respuesta.data.map(wo => {
                return wo.nim
            });

            localStorage.setItem('current_work_orders', JSON.stringify(nims));

            if (search === false) {

                let request_localstorage = {
                    date1: date1,
                    date2: date2,
                    id_branch: id_branch,
                    vaild: (query == 0 ? "" : query),
                    gatos: gatos,
                    body: JSON.stringify(_formulario)
                };
                localStorage.setItem('request_workorder_listworkorder', JSON.stringify(request_localstorage));
            }

            if (_respuesta.data.length >= 1) {
                let _twou = 0;
                let _twoc = 0;
                let _twon = 0;
                let _two = 0;

                _respuesta.data.map(_find => {
                    let _wanting = false;
                    let _urgent = 0;
                    let _critical = 0;
                    let _validador = [];

                    if (_find.listProfile.length > 0) {
                        if (_find.listProfile[0].listExam.length > 0) {
                            _find.listProfile[0].listExam.forEach(({ check_specimen, id_specimen_origin }) => {
                                if (!check_specimen) {
                                    _wanting = true;
                                }
                                if (_validador.find(x => x.id === id_specimen_origin) === undefined) {
                                    _validador.push({
                                        id: id_specimen_origin,
                                    })
                                }
                            });
                        }
                    }
                    if (_find.listExam.length > 0) {
                        _find.listExam.map(({ check_specimen, id_specimen_origin, is_urgent, is_critic }) => {
                            if (!check_specimen) {
                                _wanting = true;
                            }
                            if (_validador.find(x => x.id === id_specimen_origin) === undefined) {
                                _validador.push({
                                    id: id_specimen_origin,
                                })
                            }
                            if (is_urgent) {
                                _urgent = 1;
                            }
                            if (is_critic) {
                                _critical = 2;
                            }
                        });
                    }
                    if (_urgent) {
                        _twou += 1;
                    } else if (_critical) {
                        _twoc += 1;
                    } else {
                        _twon += 1;
                    }
                    _find._wanting = _wanting;
                    _find._urgent = _urgent;
                    _find._critical = _critical;
                    _find.cont_check_specimen = _validador.length;
                    return _find;
                });
                setTotalWorkOrderUrgent(_twou);
                setTotalWorkOrderCritic(_twoc);
                setTotalWorkOrderNormal(_twon);
                _two = _twou + _twoc + _twon;
                setTotalWorkOrder(_two);
                let criticos = _respuesta.data.filter(x => x._critical === 2);
                let urgentes = _respuesta.data.filter(x => x._urgent === 1);
                let normales = _respuesta.data.filter(x => x._critical === 0 && x._urgent === 0);
                let todos = criticos.concat(urgentes).concat(normales);
                setWorkOrders(todos);



                console.log("pasas porque el nim tiene valor");
            }
            else {
                if (!first) {
                }
                setWorkOrders({});
            }
            setLoading(false);
        }
        else if (_respuesta.code === 401) {
            validarSesion(history, _respuesta.code, getWorkOrdersDay);

        }
        else if (_respuesta.code === 409) {
            setWorkOrders({});
            createSweet("info", "info", "Consulta", _respuesta.data.msg);

        }
        else if (_respuesta.code === 500) {
            createSweet("error", "error", "Consulta", "Ocurrio un error en el servidor");
        }
        else {
            createSweet("error", "warning", "Consulta", _respuesta.data.msg);
        }
    }
    //#endregion WorkOrders


    const navigateConfigPrices = (id_work_order) => {
        history.push("../busqueda/" + id_work_order + "/detalle-orden");
    }

    function navigateCaptureResults(nim) {

        let work_order = workOrders.find(x => x.nim === nim);
        if (work_order.is_micro) {
            history.push(`../captura-resultados-sanitaria/${nim}`);
        } else {
            history.push(`../captura-resultados/${nim}`);
        }
    }

    const navigateUpdate = (workOrderId) => {
        let _value = "" + workOrderId + "";
        history.push(`../admisiones/${_value}/editar`);
    }
    //#endregion List Exam

    //#region Range Nim
    const changeFiltersRangeNim = (_value, type) => {
        let _data = filterRangeNims;
        switch (type) {
            case "date_range_nim":
                _data.date_range_nim = new moment(_value).format('YYYY/MM/DD');
                break;
            case "branch_range_nim":
                _data.branch_range_nim = _value.value;
                break;
            case "init_range_nim":
                _data.init_range_nim = _value;
                break;
            case "end_range_nim":
                _data.end_range_nim = _value;
                break;
            default:
                break;
        }
        setFilterRangeNims(_data);
    }

    const getNimsFromRange = async () => {

        if (filterRangeNims.branch_range_nim === "" || filterRangeNims.init_range_nim === "" || filterRangeNims.end_range_nim === "") {
            createSweet("warning", "warning", "Alerta", "Debes llenar todos los campos para poder filtrar por rango");
            return;
        }

        const _response = await handleRequest("POST", "WorkOrder/GetWorkOrdersFromRangeNim", "Range", filterRangeNims);

        if (_response !== null) {
            let _twou = 0;
            let _twoc = 0;
            let _twon = 0;
            let _two = 0;

            _response.map(element => {
                let validar_faltantes = false;
                let _urgent = 0;
                let _critical = 0;
                let _validador = [];

                if (element.listProfile.length > 0) {
                    if (element.listProfile[0].listExam.length > 0) {
                        element.listProfile[0].listExam.forEach(({ check_specimen, id_specimen_origin }) => {
                            if (!check_specimen) {
                                validar_faltantes = true;
                            }
                            if (_validador.find(x => x.id === id_specimen_origin) === undefined) {
                                _validador.push({
                                    id: id_specimen_origin,
                                })
                            }
                        });
                    }
                }
                if (element.listExam.length > 0) {
                    element.listExam.map(({ check_specimen, id_specimen_origin, is_urgent, is_critic }) => {
                        if (!check_specimen) {
                            validar_faltantes = true;
                        }
                        if (_validador.find(x => x.id === id_specimen_origin) === undefined) {
                            _validador.push({
                                id: id_specimen_origin,
                            })
                        }
                        if (is_urgent) {
                            _urgent = 1;
                        }
                        if (is_critic) {
                            _critical = 2;
                        }
                    });
                }
                if (_urgent) {
                    _twoc += 1;
                } else if (_critical) {
                    _twoc += 1;
                } else {
                    _twon += 1;
                }
                element.validar_faltantes = validar_faltantes;
                element._urgent = _urgent;
                element._critical = _critical;
                element.cont_check_specimen = _validador.length;
                return element;
            })
            setTotalWorkOrderUrgent(_twou);
            setTotalWorkOrderCritic(_twoc);
            setTotalWorkOrderNormal(_twon);
            _two = _twou + _twoc + _twon;
            setTotalWorkOrder(_two);
        }
        let criticos = _response.filter(x => x._critical === 2);
        let urgentes = _response.filter(x => x._urgent === 1);
        let normales = _response.filter(x => x._critical === 0 && x._urgent === 0);
        let todos = criticos.concat(urgentes).concat(normales);
        setWorkOrders(todos);
    }
    //#endregion Range Nim


    const printTicket = async (id_work_order) => {
        if (id_work_order > 0) {
            await fetch(ConfigServer.serverUrl + "/api/PrintTicket/PrintTicket/" + id_work_order, {
                method: 'POST',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {
                    if (response.status !== 200) {
                        createSweet("warning", "warning", "No se descargo el Ticket");
                        return;
                    }
                    return response.blob();
                })
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "ticket.pdf")
                    document.body.appendChild(link);
                    link.style.display = 'none';
                    link.click();
                })
        }
    }

    const printSticker = async (id_work_order) => {
        if (id_work_order > 0) {
            await fetch(ConfigServer.serverUrl + "/api/PrintTicket/PrintStickers/" + id_work_order, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {
                    if (response.status !== 200) {
                        createSweet("warning", "warning", "No se descargo el Ticket");
                        return;
                    }
                    return response.blob();
                })
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "etiquetas.pdf")
                    document.body.appendChild(link);
                    link.style.display = 'none';
                    link.click();
                })
        }
    }

    const printStickerMicro = async (id_workOrder) => {
        if (id_workOrder > 0) {
            await fetch(ConfigServer.serverUrl + "/api/PrintTicket/PrintStickersMicro/" + id_workOrder, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {
                    if (response.status !== 200) {
                        createSweet("warning", "warning", "No se descargo el Ticket");
                        return;
                    }
                    return response.blob();
                })
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "etiquetas.pdf")
                    document.body.appendChild(link);
                    link.style.display = 'none';
                    link.click();
                })
        }
    }


    //! SEARCH EXAMS AND SELECTED SECTIONS
    // useEffect(() => {
    //     if (selectedSections === null) {

    //     }
    //     else {
    //         let _arraySections = [];

    //         selectedSections.forEach(_id => {
    //             _arraySections.push({
    //                 id: _id.code
    //             })
    //             getFilterExams(_arraySections)
    //         });
    //     }

    // }, [selectedSections !== null])
    useEffect(() => {
        if (selectedSections !== null) {

            let ids = selectedSections.map(x => x.code);

            getFilterExams(ids);
        }

    }, [selectedSections]);


    //!SELECTED ARRAY SECTIONS
    const getFilterExams = async (id_state) => {
        // console.log("🌍 id_state", id_state);

        let listTmp = await handleRequest("GET", `Exam/ListExams?ids_sections=${id_state}`, 'Busqueda');
        if (listTmp !== null && listTmp.length > 0) {
            let listTmpMunicipalities = [];
            let _id = 0

            listTmp.forEach(_municipality => {
                listTmpMunicipalities.push({
                    label: _municipality.name,
                    value: _municipality.id_exam,
                    _id: _municipality.id_exam
                });
            });

            handleUpdateValues({
                ...formValues,
                mExam: _id
            });

            setListExams(listTmpMunicipalities);
        }
    }

    const getTypeService = async () => {
        let listTmp = await handleRequest("GET", "WorkOrderServiceType/List", 'Tipo de Servicio');

        if (listTmp !== null && listTmp.length > 0) {
            let listTmpTypeService = [];
            listTmp.forEach((_typeService) => {
                listTmpTypeService.push({
                    label: _typeService.name,
                    value: _typeService.id_work_order_type_service,
                })
            });
            setDataTypeService(listTmpTypeService)

        }
    }

    // ? CONFIGURATION DATA TABLE
    const rowExpansionTemplate2 = (data) => {
        const columnsPerRow = 5;

        const rows = [];
        for (let i = 0; i < data.length; i += columnsPerRow) {
            rows.push(data.slice(i, i + columnsPerRow));
        }
    }



    useEffect(() => {
        localStorage.setItem("workOrdersSearch", globalFilter2);
    }, [globalFilter2]);

    const filteredWorkOrders = Array.isArray(workOrders)
        ? workOrders.filter((workOrder) => {

            let passTypeFilter = true;

            if (filterType === "criticas") {
                passTypeFilter = workOrder._critical === 2;
            } else if (filterType === "urgentes") {
                passTypeFilter = workOrder._urgent === 1;
            } else if (filterType === "normales") {
                passTypeFilter =
                    workOrder._critical !== 2 &&
                    workOrder._urgent !== 1;
            }

            let passGlobalFilter = true;

            if (globalFilter2?.trim()) {
                const search = globalFilter2.toLowerCase();

                passGlobalFilter =
                    workOrder?.company_name?.toLowerCase().includes(search) ||
                    workOrder?.nim?.toLowerCase().includes(search) ||
                    workOrder?.name_patient?.toLowerCase().includes(search) ||
                    workOrder?.contract_number_agreement?.toLowerCase().includes(search) ||

                    workOrder?.name_branch?.toLowerCase().includes(search);
            }

            return passTypeFilter && passGlobalFilter;
        })
        : [];


    // * CONFURATION CREDIT DETAILS
    function exportToExcel(_filter) {

        let _array = _filter;
        let _Report = []

        _array.forEach((_find, key) => {
            const reportObject = {
                "Nim": _find.nim ?? "---",
                "Nombre del paciente": _find.name_patient || "N/A",
                "Sucursal": _find.name_branch ?? "N/A",
                "Fecha de admisión": _find.admision_date ?? "---",
                "Hora de admisión": _find.fechAndDate ?? "---",
                "Tipo de ingreso": _find.income_type ?? "---",
                "Nombre del cliente": _find.income_type === "Empresas" ? _find.name_company : "N/A" ?? "---",
                "Tipo de urgencia": _find._critical === 2 ? "Critico" : _find._urgent === 1 ? "Urgente" : "Normal"
            };
            _Report.push(reportObject);
        });

        const worksheet = XLSX.utils.json_to_sheet(_Report);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const fileName = 'Trabajo del dia.xlsx';
        if (typeof window !== 'undefined' && window.navigator?.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
        } else {
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }

    // ? CONFIGURATIO DATATABLE
    const renderStatusTag = (items) => {
        const baseStyle = { width: "82px", fontSize: "10px", textAlign: "center" };

        switch (items.id_status) {
            case 1:
                return <Tag style={baseStyle} severity="info" value="Abierta" />;
            case 2:
                return <Tag style={baseStyle} severity="warning" value="En Progreso" />;
            case 4:
                return <Tag style={baseStyle} severity="warning" value="Validada" />;
            case 5:
                return <Tag style={baseStyle} severity="warning" value="Parcial" />;
            case 6:
                return <Tag style={baseStyle} severity="warning" value="Liberado" />;
            case 7:
                return <Tag style={baseStyle} severity="success" value="Enviado" />;
            case 8:
                return <Tag style={baseStyle} severity="success" value="Entregado" />;
            case 9:
                return <Tag style={baseStyle} severity="success" value="Ent/Env" />;
            case 10:
                return <Tag style={{ ...baseStyle, backgroundColor: "#ff8000", color: "#fff" }} value="Autorizado" />;
            case 13:
                return <Tag style={baseStyle} severity="warning" value="Impresa" />;
            case 20:
                return <Tag style={baseStyle} severity="danger" value="Cancelada" />;
            default:
                return <Tag style={baseStyle} severity="secondary" value="Sin estatus" />;
        }
    };

    // * CONFIGURATION TYPE SAMPLINGS

    const [itemsTree, setItemsTree] = useState([]);

    const [modalCheckSpecimen, setModalCheckSpecimen] = useState(false);
    const [loadingSpecimen, setLoadingSpecimen] = useState(false)

    const toggleListExamEmail = () => {
        setModalCheckSpecimen(!modalCheckSpecimen);
        setItemsTree([]);
    }

    const handleViewExamTree = (nim) => {
        getDataFromNimPost(nim);
        toggleListExamEmail();

    }




    const getDataFromNimPost = async (nimm) => {
        setLoadingSpecimen(true);

        let _newForm = {
            nim: nimm.substring(0, 13),
            id_departament: 1
        }
        let _listTmp = await handleRequest("POST", "Sass/GetDataFromPatient", "Sample", _newForm);


        if (_listTmp !== null) {
            let _arrayNuevo = [];
            _listTmp.lista_pruebas.forEach(_find => {
                _arrayNuevo.push({
                    "profiles": _find.listProfile,
                    "exams": _find.listExam,
                })
                setLoadingSpecimen(false);


                let tree = createTree(_arrayNuevo);
                setItemsTree(tree);
            });


        }
    }

    const createTree = (_arrayNuevo) => {

        let _tree = [];
        _arrayNuevo.forEach(_find => {

            if (_find.exams.length > 0) {
                _find.exams.forEach(_e => {
                    let _exam_Curve = [];
                    if (_e.is_curve) {
                        _e.arrayCurvesSampling.forEach((_curve, _key) => {
                            _exam_Curve.push({
                                "id": _curve.id_work_order_sticker ?? 0,
                                "isLeaf": _curve.is_toma_curv,
                                "state": _curve.is_complete ? 1 : 2,
                                "text": _curve.barcode ?? "-----",
                                "is_toma": _curve.is_toma_curve ?? false,
                                "id_work_order_sticker": _curve.id_work_order_sticker,
                                id_work_order_exam: _curve.id_work_order_exam,
                                "check_forwarded": _e.check_forwarded,
                                "is_curve": _e?.is_curve,
                                "id_work_order": _e.id_work_order,
                                is_complete: _curve.is_complete,
                            })
                        });
                    }

                    _tree.push({
                        "expanded": true,
                        "children": _e?.is_curve ? _exam_Curve : [],
                        "id": _e.id_work_order_exam,
                        "id_work_order": _e.id_work_order,
                        "id_exam": _e.id_exam,
                        "state": _e.refused_check_specimen === false ? 1 : 2,
                        "text": _e.name,
                        "isLeaf": _e.check_specimen,
                        "refused_check_specimen": _e.refused_check_specimen,
                        "check_forwarded": _e.check_forwarded,
                        "is_toma": _e.refused_check_specimen === false ? _find.is_toma : '',
                        "is_curve": _e?.is_curve

                    })
                });
            }

            if (_find.profiles.length > 0) {
                _find.profiles.forEach(_p => {
                    let examenes_aux = [];

                    _p.listExam.forEach((_e, Key) => {
                        examenes_aux.push({
                            "id": _e.id_work_order_exam,
                            "id_work_order": _e.id_work_order,
                            "id_exam": _e.id_exam,
                            "isLeaf": _e.check_specimen,
                            "state": _e.refused_check_specimen === false ? 1 : 2,
                            "text": _e.name,
                            "refused_check_specimen": _e.refused_check_specimen,
                            "check_forwarded": _e.check_forwarded,
                            "is_toma": _e.refused_check_specimen === false ? _find.is_toma : ''
                        })
                    });

                    _tree.push({
                        "children": examenes_aux,
                        "state": 1,
                        "text": _p.name_profile,
                        "is_toma": _find.is_toma,
                        "check_forwarded": false,
                        "refused_check_specimen": false
                    })

                });
            }
        });

        return _tree;
    }

    const onRenderItem = (_find) => {
        return (
            <div className="treeview-item-example">
                {
                    _find.state === 1 && _find.check_forwarded === false ?
                        <span style={{ color: "#51bb25" }} >
                            <i className="icofont icofont-laboratory f-12"></i>{_find.text}&nbsp;


                        </span>
                        :
                        _find.state === 1 && _find.check_forwarded === true ?
                            <span>
                                <i className="icofont icofont-laboratory f-12"></i>{_find.text}&nbsp;

                            </span>
                            :
                            <span style={{ color: '#FF8F00' }}>
                                <i style={{ color: '#FF8F00' }} className="icofont icofont-laboratory f-12"></i>{_find.text}&nbsp;

                            </span>
                }
            </div>
        )
    }




    // ? CONFIGURATION SAMPLE
    const handleGetTraceability = async (_id) => {
        setLoadingTrazability(true);

        const response = await handleRequest("GET", `Sass/GetTraceability/${_id}`, 'sample');

        if (response && Array.isArray(response)) {
            const estudios = [];

            response.forEach(item => {
                const profileGroups = {};

                if (Array.isArray(item.traceabilitExams)) {
                    item.traceabilitExams.forEach(exam => {
                        const arrayCurves = (exam?.arrayCurves ?? []).sort((a, b) => a.num_samplings - b.num_samplings);

                        estudios.push({
                            id_exam: exam?.id_exam ?? 0,
                            id_work_order_exam: exam?.id_work_order_exam ?? 0,
                            name: (
                                <label
                                    style={
                                        exam?.check_forwarded
                                            ? { color: "#245075" }
                                            : exam?.is_curve
                                                ? (
                                                    exam?.arrayCurves?.every(curve => !!curve?.user_flebo)
                                                        ? { color: "#51bb25" }
                                                        : { color: "#FF8F00" }
                                                )
                                                : (
                                                    exam?.traceabilitSampling.length === 0
                                                        ? { color: "#FF8F00" }
                                                        : { color: "#51bb25" }
                                                )
                                    }
                                >
                                    {exam?.name ?? "---"}
                                </label>
                            ),
                            refused_check_specimen: exam?.refused_check_specimen ?? "---",
                            check_forwarded: exam?.check_forwarded ?? "---",
                            is_send1: exam?.is_send1 ?? false,
                            is_send2: exam?.is_send2 ?? false,
                            is_toma: exam?.is_toma ?? false,
                            pending: exam?.pending ?? false,
                            traceabilitSampling: exam?.traceabilitSampling ?? [],
                            traceabilitSend: exam?.traceabilitSend ?? [],
                            type: 'exam',
                            is_curve: exam?.is_curve ?? false,
                            arrayCurves: arrayCurves ?? []
                        });
                    });
                }

                if (Array.isArray(item.traceabilitProfiles)) {
                    item.traceabilitProfiles.forEach(profile => {

                        if (!profileGroups[profile.name_profile]) {
                            profileGroups[profile.name_profile] = [];
                        }

                        let profileNameColor = '';

                        profile.listExam.forEach(_exams => {

                            const examColor = _exams?.check_forwarded ? { color: "#245075" } : _exams?.traceabilitSampling.length === 0 ? { color: '#FF8F00' } : { color: "#51bb25" };

                            if (_exams?.traceabilitSampling.length === 0) {
                                profileNameColor = '#FF8F00';
                            } else if (!_exams?.check_forwarded) {
                                profileNameColor = '#51bb25';
                            } else {
                                profileNameColor = '#245075';
                            }

                            profileGroups[profile.name_profile].push({
                                id_exam: _exams?.id_exam ?? 0,
                                id_work_order_exam: _exams.id_work_order_exam ?? 0,
                                name: <label style={examColor}>{_exams.name ?? "---"}</label>,
                                refused_check_specimen: _exams.refused_check_specimen ?? false,
                                check_forwarded: _exams.check_forwarded ?? false,
                                is_send1: _exams.is_send1 ?? false,
                                is_send2: _exams.is_send2 ?? false,
                                is_toma: _exams.is_toma ?? false,
                                pending: _exams.pending ?? false,
                                traceabilitSampling: _exams.traceabilitSampling ?? [],
                                traceabilitSend: _exams.traceabilitSend ?? [],
                                type: 'exam',
                                profile_name: profile?.name_profile ?? "---"
                            });
                        });

                        estudios.push({
                            type: 'profile',
                            profile_name: <label style={{ color: profileNameColor }}>{profile?.name_profile ?? "---"}</label>,
                            listExm: profileGroups[profile.name_profile]
                        });
                    });
                }
            });


            setDataTraceability(estudios);
        }

        setLoadingTrazability(false);
    };


    const handleShowTraceability = async (event, id_work_order, nim) => {
        opTraceability.current.toggle(event);
        setSelectedNim(nim);

        await handleGetTraceability(id_work_order);

    };









    //GLOBAL REQUEST
    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }

    const OptionsCheck = [
        { label: "Similitud", value: false },
        { label: "Exacta", value: true }
    ];

    return {
        totalWorkOrderUrgent, totalWorkOrderCritic, totalWorkOrderNormal, totalWorkOrder, sections, changeCheckbox,
        mDateRange1, mDateRange2, mSelectBranch, nim, branches, handleInputChange, handleSelectValues, getWorkOrders, loading, workOrders, handlePickerValues,
        navigateConfigPrices, navigateCaptureResults, navigateUpdate,
        selectedSections, sectiondefault, printSticker, printTicket,
        changeFiltersRangeNim, filterRangeNims, getNimsFromRange,
        statusOrder, mSelectStatus, resetLocalStorage, printStickerMicro, listExams,
        mSelectTypeService, dataTypeService,
        expandedRows2, setExpandedRows2, filterType, setFilterType, rowExpansionTemplate2, filteredWorkOrders, exportToExcel,
        renderStatusTag,
        globalFilter2, setGlobalFilter2,
        modalCheckSpecimen, toggleListExamEmail, handleViewExamTree,
        treeviewRef, itemsTree, onRenderItem, loadingSpecimen, OptionsCheck, setMatchExact, match_exact,

        // ? CONFIGURATION TRACEABILITY
        dataTraceability, loadingTrazability, handleShowTraceability,
        opTraceability, selectedNim,
        _capture_lock, enable_tracking_toma, _menu





    }
}